export const ECONOMIC_DATA = "ECONOMIC_DATA";
export const ECONOMIC_BY_TYPE = "ECONOMIC_BY_TYPE";